// // // // // import React, { useState, useEffect } from 'react';
// // // // // import {
// // // // //   Table,
// // // // //   TableBody,
// // // // //   TableCell,
// // // // //   TableContainer,
// // // // //   TableHead,
// // // // //   TableRow,
// // // // //   Paper,
// // // // //   Typography,
// // // // //   CircularProgress,
// // // // //   Box,
// // // // //   Avatar,
// // // // // } from '@mui/material';
// // // // // import { getAllReporters } from '../../../services/adminService';

// // // // // const ReportersListPage = () => {
// // // // //   const [reporters, setReporters] = useState([]);
// // // // //   const [loading, setLoading] = useState(true);
// // // // //   const [error, setError] = useState(null);

// // // // //   useEffect(() => {
// // // // //     const fetchReporters = async () => {
// // // // //       setLoading(true);
// // // // //       setError(null);

// // // // //       try {
// // // // //         const response = await getAllReporters();

// // // // //         if (response.success) {
// // // // //           setReporters(response.data);
// // // // //         } else {
// // // // //           setError(response.message || "Failed to fetch reporters.");
// // // // //         }
// // // // //       } catch (err) {
// // // // //         console.error("Error fetching reporters:", err);
// // // // //         let errorMessage = "An unexpected error occurred while fetching reporters.";
// // // // //         if (err.response) {
// // // // //           errorMessage = err.response.data.message || errorMessage;
// // // // //         } else if (err.request) {
// // // // //           errorMessage = "No response from server. Please check your network connection.";
// // // // //         } else {
// // // // //           errorMessage = err.message || errorMessage;
// // // // //         }
// // // // //         setError(errorMessage);
// // // // //       } finally {
// // // // //         setLoading(false);
// // // // //       }
// // // // //     };

// // // // //     fetchReporters();
// // // // //   }, []);

// // // // //   if (loading) {
// // // // //     return (
// // // // //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
// // // // //         <CircularProgress />
// // // // //         <Typography variant="h6" sx={{ ml: 2 }}>Loading Reporters...</Typography>
// // // // //       </Box>
// // // // //     );
// // // // //   }

// // // // //   if (error) {
// // // // //     return (
// // // // //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
// // // // //         <Typography variant="h6" color="error">Error: {error}</Typography>
// // // // //       </Box>
// // // // //     );
// // // // //   }

// // // // //   if (reporters.length === 0) {
// // // // //     return (
// // // // //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
// // // // //         <Typography variant="h6">No reporters found.</Typography>
// // // // //       </Box>
// // // // //     );
// // // // //   }

// // // // //   return (
// // // // //     <Box sx={{ p: 3 }}>
// // // // //       <Typography variant="h4" component="h1" gutterBottom align="center">
// // // // //         Registered Reporters
// // // // //       </Typography>
// // // // //       <TableContainer component={Paper} sx={{ mt: 3 }}>
// // // // //         <Table sx={{ minWidth: 650 }} aria-label="simple table">
// // // // //           <TableHead>
// // // // //             <TableRow>
// // // // //               <TableCell>#</TableCell>
// // // // //               <TableCell>Profile</TableCell>
// // // // //               <TableCell>Name</TableCell>
// // // // //               <TableCell>Email</TableCell>
// // // // //               <TableCell>Role</TableCell>
// // // // //               <TableCell>Location</TableCell>
// // // // //               <TableCell align="center">Can Direct Post</TableCell>
// // // // //               <TableCell align="center">Can Direct Go Live</TableCell>
// // // // //               <TableCell>Registered On</TableCell>
// // // // //             </TableRow>
// // // // //           </TableHead>
// // // // //           <TableBody>
// // // // //             {reporters.map((reporter, index) => (
// // // // //               <TableRow key={reporter._id}>
// // // // //                 <TableCell>{index + 1}</TableCell>
// // // // //                 <TableCell>
// // // // //                   <Avatar 
// // // // //                     src={reporter.profileImage || '/default-profile.png'} 
// // // // //                     alt={reporter.name} 
// // // // //                     sx={{ width: 40, height: 40 }} 
// // // // //                   />
// // // // //                 </TableCell>
// // // // //                 <TableCell>{reporter.name}</TableCell>
// // // // //                 <TableCell>{reporter.email}</TableCell>
// // // // //                 <TableCell>{reporter.role}</TableCell>
// // // // //                 <TableCell>
// // // // //                   {reporter.city ? `${reporter.city}, ` : ''}
// // // // //                   {reporter.state ? `${reporter.state}, ` : ''}
// // // // //                   {reporter.country || 'N/A'}
// // // // //                 </TableCell>
// // // // //                 <TableCell align="center">{reporter.canDirectPost ? 'Yes' : 'No'}</TableCell>
// // // // //                 <TableCell align="center">{reporter.canDirectGoLive ? 'Yes' : 'No'}</TableCell>
// // // // //                 <TableCell>{new Date(reporter.createdAt).toLocaleDateString()}</TableCell>
// // // // //               </TableRow>
// // // // //             ))}
// // // // //           </TableBody>
// // // // //         </Table>
// // // // //       </TableContainer>
// // // // //     </Box>
// // // // //   );
// // // // // };

// // // // // export default ReportersListPage;


// // // // import React, { useState, useEffect } from 'react';
// // // // import {
// // // //   Table,
// // // //   TableBody,
// // // //   TableCell,
// // // //   TableContainer,
// // // //   TableHead,
// // // //   TableRow,
// // // //   Paper,
// // // //   Typography,
// // // //   CircularProgress,
// // // //   Box,
// // // //   Avatar,
// // // //   IconButton,
// // // //   Tooltip,
// // // // } from '@mui/material';
// // // // import { Edit, Delete } from '@mui/icons-material';
// // // // import { getAllReporters, deleteReporterById } from '../../../services/adminService';
// // // // import { useNavigate } from 'react-router-dom';
// // // // import { toast } from 'react-toastify';

// // // // const ReportersListPage = () => {
// // // //   const [reporters, setReporters] = useState([]);
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [error, setError] = useState(null);
// // // //   const navigate = useNavigate();

// // // //   useEffect(() => {
// // // //     const fetchReporters = async () => {
// // // //       setLoading(true);
// // // //       setError(null);

// // // //       try {
// // // //         const response = await getAllReporters();
// // // //         if (response.success) {
// // // //           setReporters(response.data);
// // // //         } else {
// // // //           setError(response.message || "Failed to fetch reporters.");
// // // //         }
// // // //       } catch (err) {
// // // //         console.error("Error fetching reporters:", err);
// // // //         let errorMessage = "An unexpected error occurred while fetching reporters.";
// // // //         if (err.response) {
// // // //           errorMessage = err.response.data.message || errorMessage;
// // // //         } else if (err.request) {
// // // //           errorMessage = "No response from server. Please check your network connection.";
// // // //         } else {
// // // //           errorMessage = err.message || errorMessage;
// // // //         }
// // // //         setError(errorMessage);
// // // //       } finally {
// // // //         setLoading(false);
// // // //       }
// // // //     };

// // // //     fetchReporters();
// // // //   }, []);

// // // //   const handleEdit = (id) => {
// // // //     navigate(`/admin/edit-reporter/${id}`);
// // // //   };

// // // //   const handleDelete = async (id) => {
// // // //     const confirm = window.confirm("Are you sure you want to delete this reporter?");
// // // //     if (!confirm) return;

// // // //     try {
// // // //       const res = await deleteReporterById(id);
// // // //       toast.success(res.message);
// // // //       // remove deleted reporter from state
// // // //       setReporters(prev => prev.filter(r => r.id !== id));
// // // //     } catch (err) {
// // // //       console.error("Delete error:", err);
// // // //       toast.error(err.response?.data?.message || "Failed to delete reporter");
// // // //     }
// // // //   };

// // // //   if (loading) {
// // // //     return (
// // // //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
// // // //         <CircularProgress />
// // // //         <Typography variant="h6" sx={{ ml: 2 }}>Loading Reporters...</Typography>
// // // //       </Box>
// // // //     );
// // // //   }

// // // //   if (error) {
// // // //     return (
// // // //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
// // // //         <Typography variant="h6" color="error">Error: {error}</Typography>
// // // //       </Box>
// // // //     );
// // // //   }

// // // //   if (reporters.length === 0) {
// // // //     return (
// // // //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
// // // //         <Typography variant="h6">No reporters found.</Typography>
// // // //       </Box>
// // // //     );
// // // //   }

// // // //   return (
// // // //     <Box sx={{ p: 3 }}>
// // // //       <Typography variant="h4" component="h1" gutterBottom align="center">
// // // //         Registered Reporters
// // // //       </Typography>
// // // //       <TableContainer component={Paper} sx={{ mt: 3 }}>
// // // //         <Table sx={{ minWidth: 650 }} aria-label="reporters table">
// // // //           <TableHead>
// // // //             <TableRow>
// // // //               <TableCell>#</TableCell>
// // // //               <TableCell>Profile</TableCell>
// // // //               <TableCell>Name</TableCell>
// // // //               <TableCell>Email</TableCell>
// // // //               <TableCell>Role</TableCell>
// // // //               <TableCell>Location</TableCell>
// // // //               <TableCell align="center">Can Direct Post</TableCell>
// // // //               <TableCell align="center">Can Direct Go Live</TableCell>
// // // //               <TableCell>Registered On</TableCell>
// // // //               <TableCell align="center">Actions</TableCell>
// // // //             </TableRow>
// // // //           </TableHead>
// // // //           <TableBody>
// // // //             {reporters.map((reporter, index) => (
// // // //               <TableRow key={reporter.id}>
// // // //                 <TableCell>{index + 1}</TableCell>
// // // //                 <TableCell>
// // // //                   <Avatar 
// // // //                     src={reporter.profileImage || '/default-profile.png'} 
// // // //                     alt={reporter.name} 
// // // //                     sx={{ width: 40, height: 40 }} 
// // // //                   />
// // // //                 </TableCell>
// // // //                 <TableCell>{reporter.name}</TableCell>
// // // //                 <TableCell>{reporter.email}</TableCell>
// // // //                 <TableCell>{reporter.role}</TableCell>
// // // //                 <TableCell>
// // // //                   {reporter.city ? `${reporter.city}, ` : ''}
// // // //                   {reporter.state ? `${reporter.state}, ` : ''}
// // // //                   {reporter.country || 'N/A'}
// // // //                 </TableCell>
// // // //                 <TableCell align="center">{reporter.canDirectPost ? 'Yes' : 'No'}</TableCell>
// // // //                 <TableCell align="center">{reporter.canDirectGoLive ? 'Yes' : 'No'}</TableCell>
// // // //                 <TableCell>{new Date(reporter.createdAt).toLocaleDateString()}</TableCell>
// // // //                 <TableCell align="center">
// // // //                   <Tooltip title="Edit">
// // // //                     <IconButton color="primary" onClick={() => handleEdit(reporter.id)}>
// // // //                       <Edit />
// // // //                     </IconButton>
// // // //                   </Tooltip>
// // // //                   <Tooltip title="Delete">
// // // //                     <IconButton color="error" onClick={() => handleDelete(reporter.id)}>
// // // //                       <Delete />
// // // //                     </IconButton>
// // // //                   </Tooltip>
// // // //                 </TableCell>
// // // //               </TableRow>
// // // //             ))}
// // // //           </TableBody>
// // // //         </Table>
// // // //       </TableContainer>
// // // //     </Box>
// // // //   );
// // // // };

// // // // export default ReportersListPage;

// // // import React, { useState, useEffect } from 'react';
// // // import {
// // //   Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
// // //   Paper, Typography, CircularProgress, Box, Avatar, IconButton,
// // //   Tooltip, Dialog, DialogTitle, DialogContent, DialogActions,
// // //   TextField, Button, Select, MenuItem, InputLabel, FormControl,
// // //   Switch, FormControlLabel // <-- Add Switch and FormControlLabel
// // // } from '@mui/material';
// // // import { Edit, Delete } from '@mui/icons-material';
// // // import {
// // //   getAllReporters,
// // //   deleteReporterById,
// // //   updateReporterById
// // // } from '../../../services/adminService';
// // // import {
// // //   getCountries,
// // //   getStatesByCountry,
// // //   getCitiesByState,
// // // } from '../../../services/apiService';
// // // import { toast } from 'react-toastify';

// // // const ReportersListPage = () => {
// // //   const [reporters, setReporters] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);

// // //   const [editOpen, setEditOpen] = useState(false);
// // //   const [selectedReporter, setSelectedReporter] = useState(null);
// // //   const [formData, setFormData] = useState({});

// // //   // State for Country, State, City dropdowns
// // //   const [countries, setCountries] = useState([]);
// // //   const [states, setStates] = useState([]);
// // //   const [cities, setCities] = useState([]);

// // //   useEffect(() => {
// // //     fetchReporters();
// // //   }, []);

// // //   const fetchReporters = async () => {
// // //     setLoading(true);
// // //     try {
// // //       const res = await getAllReporters();
// // //       if (res.success) {
// // //         setReporters(res.data);
// // //       } else {
// // //         setError(res.message || 'Error fetching reporters');
// // //       }
// // //     } catch (err) {
// // //       setError('Failed to load reporters');
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const fetchCountries = async () => {
// // //     try {
// // //       const res = await getCountries();
// // //       if (res.success) {
// // //         setCountries(res.data);
// // //       }
// // //     } catch (err) {
// // //       console.error("Error fetching countries:", err);
// // //       toast.error("Failed to load countries");
// // //     }
// // //   };

// // //   const fetchStates = async (countryId) => {
// // //     if (!countryId) {
// // //       setStates([]);
// // //       setCities([]);
// // //       return;
// // //     }
// // //     try {
// // //       const res = await getStatesByCountry(countryId);
// // //       if (res.success) {
// // //         setStates(res.data);
// // //         setCities([]); // Reset cities when country changes
// // //       }
// // //     } catch (err) {
// // //       console.error("Error fetching states:", err);
// // //       toast.error("Failed to load states");
// // //     }
// // //   };

// // //   const fetchCities = async (stateId) => {
// // //     if (!stateId) {
// // //       setCities([]);
// // //       return;
// // //     }
// // //     try {
// // //       const res = await getCitiesByState(stateId);
// // //       if (res.success) {
// // //         setCities(res.data);
// // //       }
// // //     } catch (err) {
// // //       console.error("Error fetching cities:", err);
// // //       toast.error("Failed to load cities");
// // //     }
// // //   };

// // //   const handleEdit = async (reporter) => {
// // //     setSelectedReporter(reporter);
// // //     setFormData({
// // //       name: reporter.name,
// // //       email: reporter.email,
// // //       role: reporter.role,
// // //       country: reporter.country || '',
// // //       state: reporter.state || '',
// // //       city: reporter.city || '',
// // //       address: reporter.address || '',
// // //       dateOfBirth: reporter.dateOfBirth ? new Date(reporter.dateOfBirth).toISOString().split('T')[0] : '', // Format for input type="date"
// // //       canDirectPost: reporter.canDirectPost || false, // Initialize with boolean value
// // //       canDirectGoLive: reporter.canDirectGoLive || false, // Initialize with boolean value
// // //       profileImage: reporter.profileImage || '' // Initialize profile image URL
// // //     });

// // //     await fetchCountries();

// // //     if (reporter.country) {
// // //       await fetchStates(reporter.country);
// // //       if (reporter.state) {
// // //         await fetchCities(reporter.state);
// // //       }
// // //     }

// // //     setEditOpen(true);
// // //   };

// // //   const handleEditChange = async (e) => {
// // //     const { name, value, checked, type } = e.target;
// // //     // For Switch components, use `checked` property
// // //     const newValue = type === 'checkbox' ? checked : value;

// // //     setFormData(prev => ({ ...prev, [name]: newValue }));

// // //     if (name === "country") {
// // //       setFormData(prev => ({ ...prev, state: '', city: '' }));
// // //       await fetchStates(newValue);
// // //     } else if (name === "state") {
// // //       setFormData(prev => ({ ...prev, city: '' }));
// // //       await fetchCities(newValue);
// // //     }
// // //   };

// // //   const handleUpdate = async () => {
// // //     try {
// // //       // Create a copy of formData and potentially adjust dateOfBirth format if needed
// // //       const dataToUpdate = { ...formData };
// // //       // If dateOfBirth is a string from input, you might want to convert it back to Date object or ISO string for backend
// // //       // Backend expects ISO string if you're using Mongoose Date type.
// // //       if (dataToUpdate.dateOfBirth) {
// // //          dataToUpdate.dateOfBirth = new Date(dataToUpdate.dateOfBirth).toISOString();
// // //       }

// // //       const res = await updateReporterById(selectedReporter.id, dataToUpdate);
// // //       if (res.success) {
// // //         toast.success(res.message);
// // //         // Update the reporters array with the new data from the response or formData
// // //         setReporters(prev =>
// // //           prev.map(r => r.id === selectedReporter.id ? { ...r, ...dataToUpdate } : r)
// // //         );
// // //         setEditOpen(false);
// // //       } else {
// // //         toast.error(res.message || 'Update failed');
// // //       }
// // //     } catch (err) {
// // //       toast.error(err.response?.data?.message || 'Update failed');
// // //     }
// // //   };

// // //   const handleDelete = async (id) => {
// // //     const confirm = window.confirm("Are you sure you want to delete this reporter?");
// // //     if (!confirm) return;

// // //     try {
// // //       const res = await deleteReporterById(id);
// // //       if (res.success) {
// // //         toast.success(res.message);
// // //         setReporters(prev => prev.filter(r => r.id !== id));
// // //       } else {
// // //         toast.error(res.message || "Failed to delete reporter");
// // //       }
// // //     } catch (err) {
// // //       toast.error(err.response?.data?.message || "Failed to delete reporter");
// // //     }
// // //   };

// // //   if (loading) {
// // //     return (
// // //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
// // //         <CircularProgress />
// // //         <Typography sx={{ ml: 2 }}>Loading Reporters...</Typography>
// // //       </Box>
// // //     );
// // //   }

// // //   if (error) {
// // //     return (
// // //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
// // //         <Typography color="error">Error: {error}</Typography>
// // //       </Box>
// // //     );
// // //   }

// // //   return (
// // //     <Box sx={{ p: 3 }}>
// // //       <Typography variant="h4" align="center" gutterBottom>
// // //         Registered Reporters
// // //       </Typography>
// // //       <TableContainer component={Paper} sx={{ mt: 3 }}>
// // //         <Table>
// // //           <TableHead>
// // //             <TableRow>
// // //               <TableCell>#</TableCell>
// // //               <TableCell>Profile</TableCell>
// // //               <TableCell>Name</TableCell>
// // //               <TableCell>Email</TableCell>
              
// // //               <TableCell>Location</TableCell>
// // //               <TableCell align="center">Can Direct Post</TableCell>
// // //               <TableCell align="center">Can Direct Go Live</TableCell>
// // //               <TableCell>Registered On</TableCell>
// // //               <TableCell align="center">Actions</TableCell>
// // //             </TableRow>
// // //           </TableHead>
// // //           <TableBody>
// // //             {reporters.map((reporter, index) => (
// // //               <TableRow key={reporter.id}>
// // //                 <TableCell>{index + 1}</TableCell>
// // //                 <TableCell>
// // //                   <Avatar src={reporter.profileImage || '/default-profile.png'} />
// // //                 </TableCell>
// // //                 <TableCell>{reporter.name}</TableCell>
// // //                 <TableCell>{reporter.email}</TableCell>
                
// // //                 <TableCell>
// // //                   {[reporter.city, reporter.state, reporter.country].filter(Boolean).join(', ') || 'N/A'}
// // //                 </TableCell>
// // //                 <TableCell align="center">{reporter.canDirectPost ? 'Yes' : 'No'}</TableCell>
// // //                 <TableCell align="center">{reporter.canDirectGoLive ? 'Yes' : 'No'}</TableCell>
// // //                 <TableCell>{new Date(reporter.createdAt).toLocaleDateString()}</TableCell>
// // //                 <TableCell align="center">
// // //                   <Tooltip title="Edit">
// // //                     <IconButton color="primary" onClick={() => handleEdit(reporter)}>
// // //                       <Edit />
// // //                     </IconButton>
// // //                   </Tooltip>
// // //                   <Tooltip title="Delete">
// // //                     <IconButton color="error" onClick={() => handleDelete(reporter.id)}>
// // //                       <Delete />
// // //                     </IconButton>
// // //                   </Tooltip>
// // //                 </TableCell>
// // //               </TableRow>
// // //             ))}
// // //           </TableBody>
// // //         </Table>
// // //       </TableContainer>

// // //       {/* Edit Modal */}
// // //       <Dialog open={editOpen} onClose={() => setEditOpen(false)} fullWidth maxWidth="sm">
// // //         <DialogTitle>Edit Reporter</DialogTitle>
// // //         <DialogContent dividers>
// // //           <TextField
// // //             fullWidth margin="dense" label="Name" name="name"
// // //             value={formData.name || ''} onChange={handleEditChange}
// // //           />
// // //           <TextField
// // //             fullWidth margin="dense" label="Email" name="email"
// // //             value={formData.email || ''} onChange={handleEditChange}
// // //           />
        
// // //           <TextField
// // //             fullWidth margin="dense" label="Address" name="address"
// // //             value={formData.address || ''} onChange={handleEditChange}
// // //           />
// // //           <TextField
// // //             fullWidth margin="dense" label="Date of Birth" name="dateOfBirth"
// // //             type="date"
// // //             InputLabelProps={{ shrink: true }}
// // //             value={formData.dateOfBirth || ''} onChange={handleEditChange}
// // //           />
// // //            <TextField
// // //             fullWidth margin="dense" label="Profile Image URL" name="profileImage"
// // //             value={formData.profileImage || ''} onChange={handleEditChange}
// // //           />


// // //           <FormControl fullWidth margin="dense">
// // //             <InputLabel>Country</InputLabel>
// // //             <Select
// // //               name="country"
// // //               value={formData.country || ''}
// // //               label="Country"
// // //               onChange={handleEditChange}
// // //             >
// // //               <MenuItem value=""><em>None</em></MenuItem>
// // //               {countries.map(c => (
// // //                 <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>
// // //               ))}
// // //             </Select>
// // //           </FormControl>

// // //           <FormControl fullWidth margin="dense">
// // //             <InputLabel>State</InputLabel>
// // //             <Select
// // //               name="state"
// // //               value={formData.state || ''}
// // //               label="State"
// // //               onChange={handleEditChange}
// // //               disabled={!formData.country}
// // //             >
// // //               <MenuItem value=""><em>None</em></MenuItem>
// // //               {states.map(s => (
// // //                 <MenuItem key={s._id} value={s._id}>{s.name}</MenuItem>
// // //               ))}
// // //             </Select>
// // //           </FormControl>

// // //           <FormControl fullWidth margin="dense">
// // //             <InputLabel>City</InputLabel>
// // //             <Select
// // //               name="city"
// // //               value={formData.city || ''}
// // //               label="City"
// // //               onChange={handleEditChange}
// // //               disabled={!formData.state}
// // //             >
// // //               <MenuItem value=""><em>None</em></MenuItem>
// // //               {cities.map(c => (
// // //                 <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>
// // //               ))}
// // //             </Select>
// // //           </FormControl>

// // //           <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
// // //             <FormControlLabel
// // //               control={
// // //                 <Switch
// // //                   checked={formData.canDirectPost}
// // //                   onChange={handleEditChange}
// // //                   name="canDirectPost"
// // //                   color="primary"
// // //                 />
// // //               }
// // //               label="Can Direct Post"
// // //             />
// // //             <FormControlLabel
// // //               control={
// // //                 <Switch
// // //                   checked={formData.canDirectGoLive}
// // //                   onChange={handleEditChange}
// // //                   name="canDirectGoLive"
// // //                   color="primary"
// // //                 />
// // //               }
// // //               label="Can Direct Go Live"
// // //             />
// // //           </Box>

// // //         </DialogContent>
// // //         <DialogActions>
// // //           <Button onClick={() => setEditOpen(false)}>Cancel</Button>
// // //           <Button variant="contained" onClick={handleUpdate}>Update</Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //     </Box>
// // //   );
// // // };

// // // export default ReportersListPage;

// // import React, { useState, useEffect } from 'react';
// // import {
// //   Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
// //   Paper, Typography, CircularProgress, Box, Avatar, IconButton,
// //   Tooltip, Dialog, DialogTitle, DialogContent, DialogActions,
// //   TextField, Button, Select, MenuItem, InputLabel, FormControl,
// //   Switch, FormControlLabel
// // } from '@mui/material';
// // import { Edit, Delete } from '@mui/icons-material';
// // import {
// //   getAllReporters,
// //   deleteReporterById,
// //   updateReporterById
// // } from '../../../services/adminService';
// // import {
// //   getCountries,
// //   getStatesByCountry,
// //   getCitiesByState,
// // } from '../../../services/apiService';
// // import { toast } from 'react-toastify';

// // // Helper to format location
// // const formatLocation = (reporter) => {
// //   return [
// //     reporter.city?.name,
// //     reporter.state?.name,
// //     reporter.country?.name
// //   ].filter(Boolean).join(', ') || 'N/A';
// // };

// // const ReportersListPage = () => {
// //   const [reporters, setReporters] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);

// //   const [editOpen, setEditOpen] = useState(false);
// //   const [selectedReporter, setSelectedReporter] = useState(null);
// //   const [formData, setFormData] = useState({});

// //   const [countries, setCountries] = useState([]);
// //   const [states, setStates] = useState([]);
// //   const [cities, setCities] = useState([]);

// //   useEffect(() => {
// //     fetchReporters();
// //   }, []);

// //   const fetchReporters = async () => {
// //     setLoading(true);
// //     try {
// //       const res = await getAllReporters();
// //       if (res.success) {
// //         setReporters(res.data);
// //       } else {
// //         setError(res.message || 'Error fetching reporters');
// //       }
// //     } catch (err) {
// //       setError('Failed to load reporters');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const fetchCountries = async () => {
// //     try {
// //       const res = await getCountries();
// //       if (res.success) setCountries(res.data);
// //     } catch (err) {
// //       toast.error("Failed to load countries");
// //     }
// //   };

// //   const fetchStates = async (countryId) => {
// //     if (!countryId) {
// //       setStates([]);
// //       setCities([]);
// //       return;
// //     }
// //     try {
// //       const res = await getStatesByCountry(countryId);
// //       if (res.success) {
// //         setStates(res.data);
// //         setCities([]);
// //       }
// //     } catch {
// //       toast.error("Failed to load states");
// //     }
// //   };

// //   const fetchCities = async (stateId) => {
// //     if (!stateId) {
// //       setCities([]);
// //       return;
// //     }
// //     try {
// //       const res = await getCitiesByState(stateId);
// //       if (res.success) setCities(res.data);
// //     } catch {
// //       toast.error("Failed to load cities");
// //     }
// //   };

// //   const handleEdit = async (reporter) => {
// //     setSelectedReporter(reporter);
// //     setFormData({
// //       name: reporter.name,
// //       email: reporter.email,
// //       role: reporter.role,
// //       country: reporter.country?.id || '',
// //       state: reporter.state?.id || '',
// //       city: reporter.city?.id || '',
// //       address: reporter.address || '',
// //       dateOfBirth: reporter.dateOfBirth
// //         ? new Date(reporter.dateOfBirth).toISOString().split('T')[0]
// //         : '',
// //       canDirectPost: reporter.canDirectPost || false,
// //       canDirectGoLive: reporter.canDirectGoLive || false,
// //       profileImage: reporter.profileImage || ''
// //     });

// //     await fetchCountries();
// //     if (reporter.country?.id) {
// //       await fetchStates(reporter.country.id);
// //       if (reporter.state?.id) {
// //         await fetchCities(reporter.state.id);
// //       }
// //     }

// //     setEditOpen(true);
// //   };

// //   const handleEditChange = async (e) => {
// //     const { name, value, checked, type } = e.target;
// //     const newValue = type === 'checkbox' ? checked : value;

// //     setFormData(prev => ({ ...prev, [name]: newValue }));

// //     if (name === "country") {
// //       setFormData(prev => ({ ...prev, state: '', city: '' }));
// //       await fetchStates(newValue);
// //     } else if (name === "state") {
// //       setFormData(prev => ({ ...prev, city: '' }));
// //       await fetchCities(newValue);
// //     }
// //   };

// //   const handleUpdate = async () => {
// //     try {
// //       const dataToUpdate = { ...formData };
// //       if (dataToUpdate.dateOfBirth) {
// //         dataToUpdate.dateOfBirth = new Date(dataToUpdate.dateOfBirth).toISOString();
// //       }

// //       const res = await updateReporterById(selectedReporter.id, dataToUpdate);
// //       if (res.success) {
// //         toast.success(res.message);
// //         setReporters(prev =>
// //           prev.map(r => r.id === selectedReporter.id ? { ...r, ...dataToUpdate } : r)
// //         );
// //         setEditOpen(false);
// //       } else {
// //         toast.error(res.message || 'Update failed');
// //       }
// //     } catch (err) {
// //       toast.error(err.response?.data?.message || 'Update failed');
// //     }
// //   };

// //   const handleDelete = async (id) => {
// //     const confirm = window.confirm("Are you sure you want to delete this reporter?");
// //     if (!confirm) return;

// //     try {
// //       const res = await deleteReporterById(id);
// //       if (res.success) {
// //         toast.success(res.message);
// //         setReporters(prev => prev.filter(r => r.id !== id));
// //       } else {
// //         toast.error(res.message || "Failed to delete reporter");
// //       }
// //     } catch (err) {
// //       toast.error(err.response?.data?.message || "Failed to delete reporter");
// //     }
// //   };

// //   if (loading) {
// //     return (
// //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
// //         <CircularProgress />
// //         <Typography sx={{ ml: 2 }}>Loading Reporters...</Typography>
// //       </Box>
// //     );
// //   }

// //   if (error) {
// //     return (
// //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
// //         <Typography color="error">Error: {error}</Typography>
// //       </Box>
// //     );
// //   }

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Typography variant="h4" align="center" gutterBottom>
// //         Registered Reporters
// //       </Typography>
// //       <TableContainer component={Paper} sx={{ mt: 3 }}>
// //         <Table>
// //           <TableHead>
// //             <TableRow>
// //               <TableCell>#</TableCell>
// //               <TableCell>Profile</TableCell>
// //               <TableCell>Name</TableCell>
// //               <TableCell>Email</TableCell>
// //               <TableCell>Location</TableCell>
// //               <TableCell align="center">Can Direct Post</TableCell>
// //               <TableCell align="center">Can Direct Go Live</TableCell>
// //               <TableCell>Registered On</TableCell>
// //               <TableCell align="center">Actions</TableCell>
// //             </TableRow>
// //           </TableHead>
// //           <TableBody>
// //             {reporters.map((reporter, index) => (
// //               <TableRow key={reporter.id}>
// //                 <TableCell>{index + 1}</TableCell>
// //                 <TableCell>
// //                   <Avatar src={reporter.profileImage || '/default-profile.png'} />
// //                 </TableCell>
// //                 <TableCell>{reporter.name}</TableCell>
// //                 <TableCell>{reporter.email}</TableCell>
// //                 <TableCell>{formatLocation(reporter)}</TableCell>
// //                 <TableCell align="center">{reporter.canDirectPost ? 'Yes' : 'No'}</TableCell>
// //                 <TableCell align="center">{reporter.canDirectGoLive ? 'Yes' : 'No'}</TableCell>
// //                 <TableCell>{new Date(reporter.createdAt).toLocaleDateString()}</TableCell>
// //                 <TableCell align="center">
// //                   <Tooltip title="Edit">
// //                     <IconButton color="primary" onClick={() => handleEdit(reporter)}>
// //                       <Edit />
// //                     </IconButton>
// //                   </Tooltip>
// //                   <Tooltip title="Delete">
// //                     <IconButton color="error" onClick={() => handleDelete(reporter.id)}>
// //                       <Delete />
// //                     </IconButton>
// //                   </Tooltip>
// //                 </TableCell>
// //               </TableRow>
// //             ))}
// //           </TableBody>
// //         </Table>
// //       </TableContainer>

// //       {/* Edit Modal */}
// //       <Dialog open={editOpen} onClose={() => setEditOpen(false)} fullWidth maxWidth="sm">
// //         <DialogTitle>Edit Reporter</DialogTitle>
// //         <DialogContent dividers>
// //           <TextField fullWidth margin="dense" label="Name" name="name" value={formData.name || ''} onChange={handleEditChange} />
// //           <TextField fullWidth margin="dense" label="Email" name="email" value={formData.email || ''} onChange={handleEditChange} />
// //           <TextField fullWidth margin="dense" label="Address" name="address" value={formData.address || ''} onChange={handleEditChange} />
// //           <TextField fullWidth margin="dense" type="date" label="Date of Birth" name="dateOfBirth"
// //             InputLabelProps={{ shrink: true }} value={formData.dateOfBirth || ''} onChange={handleEditChange}
// //           />
// //           <TextField fullWidth margin="dense" label="Profile Image URL" name="profileImage" value={formData.profileImage || ''} onChange={handleEditChange} />

// //           <FormControl fullWidth margin="dense">
// //             <InputLabel>Country</InputLabel>
// //             <Select name="country" value={formData.country || ''} label="Country" onChange={handleEditChange}>
// //               <MenuItem value=""><em>None</em></MenuItem>
// //               {countries.map(c => (
// //                 <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <FormControl fullWidth margin="dense">
// //             <InputLabel>State</InputLabel>
// //             <Select name="state" value={formData.state || ''} label="State" onChange={handleEditChange} disabled={!formData.country}>
// //               <MenuItem value=""><em>None</em></MenuItem>
// //               {states.map(s => (
// //                 <MenuItem key={s._id} value={s._id}>{s.name}</MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <FormControl fullWidth margin="dense">
// //             <InputLabel>City</InputLabel>
// //             <Select name="city" value={formData.city || ''} label="City" onChange={handleEditChange} disabled={!formData.state}>
// //               <MenuItem value=""><em>None</em></MenuItem>
// //               {cities.map(c => (
// //                 <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
// //             <FormControlLabel
// //               control={<Switch checked={formData.canDirectPost} onChange={handleEditChange} name="canDirectPost" color="primary" />}
// //               label="Can Direct Post"
// //             />
// //             <FormControlLabel
// //               control={<Switch checked={formData.canDirectGoLive} onChange={handleEditChange} name="canDirectGoLive" color="primary" />}
// //               label="Can Direct Go Live"
// //             />
// //           </Box>
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => setEditOpen(false)}>Cancel</Button>
// //           <Button variant="contained" onClick={handleUpdate}>Update</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default ReportersListPage;


// import React, { useState, useEffect } from 'react';
// import {
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
//   Paper, Typography, CircularProgress, Box, Avatar, IconButton,
//   Tooltip, Dialog, DialogTitle, DialogContent, DialogActions,
//   TextField, Button, Select, MenuItem, InputLabel, FormControl,
//   Switch, FormControlLabel
// } from '@mui/material';
// import { Edit, Delete, Image as ImageIcon } from '@mui/icons-material'; // Import ImageIcon for preview placeholder
// import { // Ensure these paths are correct
//   getAllReporters,
//   deleteReporterById,
//   updateReporterById
// } from '../../../services/adminService';
// import { // Ensure these paths are correct
//   getCountries,
//   getStatesByCountry,
//   getCitiesByState,
// } from '../../../services/apiService';
// import { toast } from 'react-toastify';

// // Helper to format location
// const formatLocation = (reporter) => {
//   return [
//     reporter.city?.name,
//     reporter.state?.name,
//     reporter.country?.name
//   ].filter(Boolean).join(', ') || 'N/A';
// };

// const ReportersListPage = () => {
//   const [reporters, setReporters] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [editOpen, setEditOpen] = useState(false);
//   const [selectedReporter, setSelectedReporter] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [profileImageFile, setProfileImageFile] = useState(null); // ⭐ New state for the actual file
//   const [profileImagePreview, setProfileImagePreview] = useState(''); // ⭐ New state for image preview URL

//   const [countries, setCountries] = useState([]);
//   const [states, setStates] = useState([]);
//   const [cities, setCities] = useState([]);

//   useEffect(() => {
//     fetchReporters();
//   }, []);

//   const fetchReporters = async () => {
//     setLoading(true);
//     try {
//       const res = await getAllReporters();
//       if (res.success) {
//         setReporters(res.data);
//       } else {
//         setError(res.message || 'Error fetching reporters');
//       }
//     } catch (err) {
//       setError('Failed to load reporters');
//       toast.error('Failed to load reporters'); // Add toast for fetching error
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchCountries = async () => {
//     try {
//       const res = await getCountries();
//       if (res.success) setCountries(res.data);
//     } catch (err) {
//       toast.error("Failed to load countries");
//     }
//   };

//   const fetchStates = async (countryId) => {
//     if (!countryId) {
//       setStates([]);
//       setCities([]);
//       return;
//     }
//     try {
//       const res = await getStatesByCountry(countryId);
//       if (res.success) {
//         setStates(res.data);
//         setCities([]); // Clear cities when state changes or is cleared
//       } else {
//           setStates([]);
//           setCities([]);
//       }
//     } catch {
//       toast.error("Failed to load states");
//       setStates([]);
//       setCities([]);
//     }
//   };

//   const fetchCities = async (stateId) => {
//     if (!stateId) {
//       setCities([]);
//       return;
//     }
//     try {
//       const res = await getCitiesByState(stateId);
//       if (res.success) setCities(res.data);
//       else {
//           setCities([]);
//       }
//     } catch {
//       toast.error("Failed to load cities");
//       setCities([]);
//     }
//   };

//   const handleEdit = async (reporter) => {
//     setSelectedReporter(reporter);
//     setFormData({
//       name: reporter.name,
//       email: reporter.email,
//       role: reporter.role,
//       country: reporter.country?.id || '', // Use .id for backend, '' for "None"
//       state: reporter.state?.id || '',
//       city: reporter.city?.id || '',
//       address: reporter.address || '',
//       // ⭐ Display existing dateOfBirth, or empty string if null/undefined
//       dateOfBirth: reporter.dateOfBirth
//         ? new Date(reporter.dateOfBirth).toISOString().split('T')[0]
//         : '',
//       canDirectPost: reporter.canDirectPost || false,
//       canDirectGoLive: reporter.canDirectGoLive || false,
//       // profileImage is not put directly into formData for file upload scenario
//     });

//     // ⭐ Set initial preview for existing image
//     setProfileImagePreview(reporter.profileImage || '');
//     setProfileImageFile(null); // Clear any previously selected file

//     // Ensure dependent fetches are awaited before opening modal to avoid empty dropdowns
//     await fetchCountries();
//     if (reporter.country?.id) {
//       await fetchStates(reporter.country.id);
//       if (reporter.state?.id) {
//         await fetchCities(reporter.state.id);
//       }
//     }

//     setEditOpen(true);
//   };

//   const handleEditChange = async (e) => {
//     const { name, value, checked, type, files } = e.target;

//     // ⭐ Handle file input separately
//     if (name === 'profileImage' && type === 'file') {
//       const file = files[0];
//       setProfileImageFile(file);
//       // Create a URL for immediate preview in the browser
//       setProfileImagePreview(file ? URL.createObjectURL(file) : '');
//     } else {
//       const newValue = type === 'checkbox' ? checked : value;
//       setFormData(prev => ({ ...prev, [name]: newValue }));

//       if (name === "country") {
//         setFormData(prev => ({ ...prev, state: '', city: '' })); // Reset state and city when country changes
//         await fetchStates(newValue);
//       } else if (name === "state") {
//         setFormData(prev => ({ ...prev, city: '' })); // Reset city when state changes
//         await fetchCities(newValue);
//       }
//     }
//   };

//   // ⭐ New function to explicitly clear the profile image
//   const handleClearProfileImage = () => {
//     setProfileImageFile(null); // Clear the file chosen in current session
//     setProfileImagePreview(''); // Clear the preview
//     // Signal to the backend that the image should be cleared by sending an empty string
//     // This is picked up by the backend's `else if (req.body.profileImage === '')`
//     setFormData(prev => ({ ...prev, profileImage: '' }));
//   };


//   const handleUpdate = async () => {
//     try {
//       // ⭐ Use FormData for file uploads
//       const dataToUpdate = new FormData();

//       // Append all text/non-file form data fields
//       for (const key in formData) {
//         // FormData needs booleans to be explicitly 'true' or 'false' strings
//         if (typeof formData[key] === 'boolean') {
//           dataToUpdate.append(key, formData[key] ? 'true' : 'false');
//         } else if (formData[key] !== null && formData[key] !== undefined) {
//           // Append the value, converting empty strings for location to null if needed (backend handles this too)
//           dataToUpdate.append(key, formData[key]);
//         }
//       }

//       // ⭐ Append the profile image file if selected
//       if (profileImageFile) {
//         dataToUpdate.append('profileImage', profileImageFile);
//       } else if (formData.profileImage === '') {
//         // ⭐ If the user clicked "Clear Image", send an empty string to signal clearing
//         dataToUpdate.append('profileImage', '');
//       }
//       // If profileImageFile is null and formData.profileImage is NOT '',
//       // it means the image field was not touched. In this case, we don't append
//       // 'profileImage' to FormData, and the backend will preserve the existing image.


//       const res = await updateReporterById(selectedReporter.id, dataToUpdate); // Pass FormData

//       if (res.success) {
//         toast.success(res.message);
//         // ⭐ CRITICAL CHANGE: Use the fully populated data returned by the backend
//         const updatedReporterFromServer = res.data;
//         setReporters(prev =>
//           prev.map(r => r.id === selectedReporter.id ? updatedReporterFromServer : r)
//         );
//         setEditOpen(false);
//         // ⭐ Clear file states after successful update
//         setProfileImageFile(null);
//         setProfileImagePreview('');
//       } else {
//         toast.error(res.message || 'Update failed');
//       }
//     } catch (err) {
//       // Access specific error message from the API response
//       toast.error(err.response?.data?.message || 'Update failed due to server error.');
//     }
//   };

//   const handleDelete = async (id) => {
//     const confirm = window.confirm("Are you sure you want to delete this reporter?");
//     if (!confirm) return;

//     try {
//       const res = await deleteReporterById(id);
//       if (res.success) {
//         toast.success(res.message);
//         setReporters(prev => prev.filter(r => r.id !== id));
//       } else {
//         toast.error(res.message || "Failed to delete reporter");
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to delete reporter");
//     }
//   };

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
//         <CircularProgress />
//         <Typography sx={{ ml: 2 }}>Loading Reporters...</Typography>
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
//         <Typography color="error">Error: {error}</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h4" align="center" gutterBottom>
//         Registered Reporters
//       </Typography>
//       <TableContainer component={Paper} sx={{ mt: 3 }}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>#</TableCell>
//               <TableCell>Profile</TableCell>
//               <TableCell>Name</TableCell>
//               <TableCell>Email</TableCell>
//               <TableCell>Location</TableCell>
//               <TableCell align="center">Can Direct Post</TableCell>
//               <TableCell align="center">Can Direct Go Live</TableCell>
//               <TableCell>Registered On</TableCell>
//               <TableCell align="center">Actions</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {reporters.map((reporter, index) => (
//               <TableRow key={reporter.id}>
//                 <TableCell>{index + 1}</TableCell>
//                 <TableCell>
//                   <Avatar src={reporter.profileImage || '/default-profile.png'} />
//                 </TableCell>
//                 <TableCell>{reporter.name}</TableCell>
//                 <TableCell>{reporter.email}</TableCell>
//                 <TableCell>{formatLocation(reporter)}</TableCell>
//                 <TableCell align="center">{reporter.canDirectPost ? 'Yes' : 'No'}</TableCell>
//                 <TableCell align="center">{reporter.canDirectGoLive ? 'Yes' : 'No'}</TableCell>
//                 <TableCell>{new Date(reporter.createdAt).toLocaleDateString()}</TableCell>
//                 <TableCell align="center">
//                   <Tooltip title="Edit">
//                     <IconButton color="primary" onClick={() => handleEdit(reporter)}>
//                       <Edit />
//                     </IconButton>
//                   </Tooltip>
//                   <Tooltip title="Delete">
//                     <IconButton color="error" onClick={() => handleDelete(reporter.id)}>
//                       <Delete />
//                     </IconButton>
//                   </Tooltip>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* Edit Modal */}
//       <Dialog open={editOpen} onClose={() => setEditOpen(false)} fullWidth maxWidth="sm">
//         <DialogTitle>Edit Reporter</DialogTitle>
//         <DialogContent dividers>
//           <TextField fullWidth margin="dense" label="Name" name="name" value={formData.name || ''} onChange={handleEditChange} />
//           <TextField fullWidth margin="dense" label="Email" name="email" value={formData.email || ''} onChange={handleEditChange} />
//           <TextField fullWidth margin="dense" label="Address" name="address" value={formData.address || ''} onChange={handleEditChange} />
//           <TextField fullWidth margin="dense" type="date" label="Date of Birth" name="dateOfBirth"
//             InputLabelProps={{ shrink: true }} value={formData.dateOfBirth || ''} onChange={handleEditChange}
//           />

//           {/* ⭐ Profile Image Upload section */}
//           <Box sx={{ my: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
//             <InputLabel shrink>Profile Image</InputLabel>
//             <Box sx={{ width: 100, height: 100, border: '1px dashed grey', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
//               {profileImagePreview ? (
//                 <Avatar src={profileImagePreview} sx={{ width: 100, height: 100 }} />
//               ) : (
//                 <ImageIcon sx={{ fontSize: 40, color: 'text.secondary' }} /> // Placeholder icon
//               )}
//             </Box>
//             <input
//               accept="image/*" // Only accept image files
//               style={{ display: 'none' }} // Hide default input
//               id="profile-image-upload"
//               type="file"
//               name="profileImage" // Match the name used in multer
//               onChange={handleEditChange}
//             />
//             <label htmlFor="profile-image-upload">
//               <Button variant="outlined" component="span">
//                 Upload Image
//               </Button>
//             </label>
//             {profileImagePreview && ( // Show clear button only if there's an image
//               <Button variant="outlined" color="error" onClick={handleClearProfileImage}>
//                 Clear Image
//               </Button>
//             )}
//           </Box>


//           <FormControl fullWidth margin="dense">
//             <InputLabel>Country</InputLabel>
//             <Select name="country" value={formData.country || ''} label="Country" onChange={handleEditChange}>
//               <MenuItem value=""><em>None</em></MenuItem>
//               {countries.map(c => (
//                 <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <FormControl fullWidth margin="dense">
//             <InputLabel>State</InputLabel>
//             <Select name="state" value={formData.state || ''} label="State" onChange={handleEditChange} disabled={!formData.country}>
//               <MenuItem value=""><em>None</em></MenuItem>
//               {states.map(s => (
//                 <MenuItem key={s._id} value={s._id}>{s.name}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <FormControl fullWidth margin="dense">
//             <InputLabel>City</InputLabel>
//             <Select name="city" value={formData.city || ''} label="City" onChange={handleEditChange} disabled={!formData.state}>
//               <MenuItem value=""><em>None</em></MenuItem>
//               {cities.map(c => (
//                 <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
//             <FormControlLabel
//               control={<Switch checked={formData.canDirectPost} onChange={handleEditChange} name="canDirectPost" color="primary" />}
//               label="Can Direct Post"
//             />
//             <FormControlLabel
//               control={<Switch checked={formData.canDirectGoLive} onChange={handleEditChange} name="canDirectGoLive" color="primary" />}
//               label="Can Direct Go Live"
//             />
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setEditOpen(false)}>Cancel</Button>
//           <Button variant="contained" onClick={handleUpdate}>Update</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default ReportersListPage;

import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography, CircularProgress, Box, Avatar, IconButton,
  Tooltip, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Select, MenuItem, InputLabel, FormControl,
  Switch, FormControlLabel, Grid, Divider
} from '@mui/material';
import { Edit, Delete, CheckCircle, Cancel, LocationOn, EventNote, Image as ImageIcon } from '@mui/icons-material'; 
import { 
  getAllReporters,
  deleteReporterById,
  updateReporterById,
  resetReporterPassword
} from '../../../services/adminService';
import { 
  getCountries,
  getStatesByCountry,
  getCitiesByState,
} from '../../../services/apiService';
import { toast } from 'react-toastify';
import { LockReset } from '@mui/icons-material';
import { LockReset as LockResetIcon, Visibility, VisibilityOff } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
// Helper to format location
const formatLocation = (reporter) => {
  return [
    reporter.city?.name,
    reporter.state?.name,
    reporter.country?.name
  ].filter(Boolean).join(', ') || 'N/A';
};

const ReportersListPage = () => {
  const [reporters, setReporters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [editOpen, setEditOpen] = useState(false);
  const [selectedReporter, setSelectedReporter] = useState(null);
  const [formData, setFormData] = useState({});
  const [profileImageFile, setProfileImageFile] = useState(null); 
  const [profileImagePreview, setProfileImagePreview] = useState(''); 

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
const [resetOpen, setResetOpen] = useState(false);
const [resetTargetId, setResetTargetId] = useState(null);
const [newPassword, setNewPassword] = useState('');
const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    fetchReporters();
  }, []);

  const fetchReporters = async () => {
    setLoading(true);
    try {
      const res = await getAllReporters();
      if (res.success) setReporters(res.data);
      else setError(res.message || 'Error fetching reporters');
    } catch (err) {
      setError('Failed to load reporters');
      toast.error('Failed to load reporters'); 
    } finally {
      setLoading(false);
    }
  };

  // ✅ Quick Toggle Permission (Table Icons Click)
  const handleTogglePermission = async (reporter, fieldName) => {
    try {
      const newValue = !reporter[fieldName];
      const data = new FormData();
      data.append(fieldName, newValue ? 'true' : 'false');

      const res = await updateReporterById(reporter.id, data);
      if (res.success) {
        toast.success(`Permission Updated`);
        setReporters(prev => prev.map(r => r.id === reporter.id ? res.data : r));
      }
    } catch (err) { toast.error("Update failed"); }
  };



  const handleResetPassword = async () => {
  if (!newPassword || newPassword.length < 5) {
    toast.error("Password kam se kam 5 characters ka ho");
    return;
  }
  try {
    const res = await resetReporterPassword(resetTargetId, newPassword);
    if (res.success) {
      toast.success(res.message);
      setResetOpen(false);
      setNewPassword('');
    }
  } catch (err) {
    toast.error("Password reset fail ho gaya");
  }
};
  // --- Dropdown Logic for Edit Dialog ---
  const fetchCountries = async () => {
    try {
      const res = await getCountries();
      if (res.success) setCountries(res.data);
    } catch (err) { toast.error("Failed to load countries"); }
  };

  const fetchStates = async (countryId) => {
    if (!countryId) { setStates([]); setCities([]); return; }
    try {
      const res = await getStatesByCountry(countryId);
      if (res.success) { setStates(res.data); setCities([]); }
    } catch { toast.error("Failed to load states"); }
  };

  const fetchCities = async (stateId) => {
    if (!stateId) { setCities([]); return; }
    try {
      const res = await getCitiesByState(stateId);
      if (res.success) setCities(res.data);
    } catch { toast.error("Failed to load cities"); }
  };

  // ✅ Open Edit Dialog (Purana Wala Detail Modal)
  const handleEdit = async (reporter) => {
    setSelectedReporter(reporter);
    setFormData({
      name: reporter.name,
      email: reporter.email,
      role: reporter.role,
      country: reporter.country?.id || '', 
      state: reporter.state?.id || '',
      city: reporter.city?.id || '',
      address: reporter.address || '',
      dateOfBirth: reporter.dateOfBirth ? new Date(reporter.dateOfBirth).toISOString().split('T')[0] : '',
      canDirectPost: reporter.canDirectPost || false,
      canDirectVideo: reporter.canDirectVideo || false,
      canDirectShorts: reporter.canDirectShorts || false,
      canDirectStory: reporter.canDirectStory || false,
      canDirectGoLive: reporter.canDirectGoLive || false,
    });

    setProfileImagePreview(reporter.profileImage || '');
    setProfileImageFile(null); 

    await fetchCountries();
    if (reporter.country?.id) {
      await fetchStates(reporter.country.id);
      if (reporter.state?.id) await fetchCities(reporter.state.id);
    }
    setEditOpen(true);
  };

  const handleEditChange = async (e) => {
    const { name, value, checked, type, files } = e.target;
    if (name === 'profileImage' && type === 'file') {
      const file = files[0];
      setProfileImageFile(file);
      setProfileImagePreview(file ? URL.createObjectURL(file) : '');
    } else {
      const newValue = type === 'checkbox' ? checked : value;
      setFormData(prev => ({ ...prev, [name]: newValue }));
      if (name === "country") await fetchStates(newValue);
      else if (name === "state") await fetchCities(newValue);
    }
  };

  const handleClearProfileImage = () => {
    setProfileImageFile(null);
    setProfileImagePreview('');
    setFormData(prev => ({ ...prev, profileImage: '' }));
  };

  const handleUpdate = async () => {
    try {
      const dataToUpdate = new FormData();
      for (const key in formData) {
        if (typeof formData[key] === 'boolean') {
          dataToUpdate.append(key, formData[key] ? 'true' : 'false');
        } else if (formData[key] !== null && formData[key] !== undefined) {
          dataToUpdate.append(key, formData[key]);
        }
      }
      if (profileImageFile) dataToUpdate.append('profileImage', profileImageFile);

      const res = await updateReporterById(selectedReporter.id, dataToUpdate);
      if (res.success) {
        toast.success(res.message);
        setReporters(prev => prev.map(r => r.id === selectedReporter.id ? res.data : r));
        setEditOpen(false);
      }
    } catch (err) { toast.error("Update failed"); }
  };

  if (loading) return <Box display="flex" justifyContent="center" sx={{ p: 5 }}><CircularProgress /></Box>;

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
        Reporter Management Dashboard
      </Typography>

      <TableContainer component={Paper} elevation={6} sx={{ mt: 3, borderRadius: 3, overflow: 'hidden' }}>
        <Table>
          <TableHead sx={{ backgroundColor: '#377fc7' }}>
            <TableRow>
              <TableCell sx={{ color: '#fff' }}>Profile</TableCell>
              <TableCell sx={{ color: '#fff' }}>Info</TableCell>
              <TableCell sx={{ color: '#fff' }}>Location</TableCell>
              <TableCell align="center" sx={{ color: '#fff' }}>News</TableCell>
              <TableCell align="center" sx={{ color: '#fff' }}>Video</TableCell>
              <TableCell align="center" sx={{ color: '#fff' }}>Shorts</TableCell>
              <TableCell align="center" sx={{ color: '#fff' }}>Story</TableCell>
              <TableCell align="center" sx={{ color: '#fff' }}>Live</TableCell>
              <TableCell sx={{ color: '#fff' }}>Joined On</TableCell>
              <TableCell align="center" sx={{ color: '#fff' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reporters.map((reporter) => (
              <TableRow key={reporter.id} hover>
                <TableCell><Avatar src={reporter.profileImage} /></TableCell>
                <TableCell>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{reporter.name}</Typography>
                  <Typography variant="caption" color="textSecondary">{reporter.email}</Typography>
                </TableCell>
                <TableCell>
                   <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
                     <LocationOn fontSize="inherit" sx={{ mr: 0.5 }} /> {formatLocation(reporter)}
                   </Typography>
                </TableCell>

                {/* --- Quick Toggle Buttons (Clickable Icons) --- */}
                <TableCell align="center">
                  <IconButton onClick={() => handleTogglePermission(reporter, 'canDirectPost')}>
                    {reporter.canDirectPost ? <CheckCircle color="success" /> : <Cancel color="disabled" />}
                  </IconButton>
                </TableCell>
                <TableCell align="center">
                  <IconButton onClick={() => handleTogglePermission(reporter, 'canDirectVideo')}>
                    {reporter.canDirectVideo ? <CheckCircle color="success" /> : <Cancel color="disabled" />}
                  </IconButton>
                </TableCell>
                <TableCell align="center">
                  <IconButton onClick={() => handleTogglePermission(reporter, 'canDirectShorts')}>
                    {reporter.canDirectShorts ? <CheckCircle color="success" /> : <Cancel color="disabled" />}
                  </IconButton>
                </TableCell>
                <TableCell align="center">
                  <IconButton onClick={() => handleTogglePermission(reporter, 'canDirectStory')}>
                    {reporter.canDirectStory ? <CheckCircle color="success" /> : <Cancel color="disabled" />}
                  </IconButton>
                </TableCell>
                <TableCell align="center">
                  <IconButton onClick={() => handleTogglePermission(reporter, 'canDirectGoLive')}>
                    {reporter.canDirectGoLive ? <CheckCircle color="error" /> : <Cancel color="disabled" />}
                  </IconButton>
                </TableCell>

                <TableCell>
                   <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
                     <EventNote fontSize="inherit" sx={{ mr: 0.5 }} /> {new Date(reporter.createdAt).toLocaleDateString('en-IN')}
                   </Typography>
                </TableCell>

                <TableCell align="center">
                  <Tooltip title="Full Edit"><IconButton color="primary" onClick={() => handleEdit(reporter)}><Edit fontSize="small"/></IconButton></Tooltip>
                  <Tooltip title="Delete"><IconButton color="error" onClick={() => {if(window.confirm("Delete?")) deleteReporterById(reporter.id).then(fetchReporters)}}><Delete fontSize="small"/></IconButton></Tooltip>
                  <Tooltip title="Reset Password">
  <IconButton color="warning" onClick={() => { setResetTargetId(reporter.id); setResetOpen(true); }}>
    <LockReset fontSize="small" />
  </IconButton>
</Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>


<Dialog 
  open={resetOpen} 
  onClose={() => setResetOpen(false)} 
  maxWidth="xs" 
  fullWidth
  PaperProps={{ sx: { borderRadius: 3 } }}
>
  <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
    <Avatar sx={{ bgcolor: 'warning.light', color: 'warning.dark' }}>
      <LockResetIcon />
    </Avatar>
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
        Reset Password
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Set a new password for this reporter
      </Typography>
    </Box>
  </DialogTitle>

  <DialogContent sx={{ pt: 1 }}>
    <TextField
      fullWidth
      margin="dense"
      autoFocus
      type={showPassword ? 'text' : 'password'}
      label="New Password"
      placeholder="Minimum 5 characters"
      value={newPassword}
      onChange={(e) => setNewPassword(e.target.value)}
      error={newPassword.length > 0 && newPassword.length < 5}
      helperText={
        newPassword.length > 0 && newPassword.length < 5
          ? 'Password kam se kam 5 characters ka ho'
          : ' '
      }
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  </DialogContent>

  <DialogActions sx={{ px: 3, pb: 2.5 }}>
    <Button onClick={() => setResetOpen(false)} color="inherit">
      Cancel
    </Button>
    <Button
      variant="contained"
      color="warning"
      disabled={newPassword.length < 5}
      onClick={handleResetPassword}
      sx={{ fontWeight: 'bold', px: 3 }}
    >
      Reset Password
    </Button>
  </DialogActions>
</Dialog>

      {/* ✅ Purana Wala Edit Dialog (Full Details) */}
      <Dialog open={editOpen} onClose={() => setEditOpen(false)} fullWidth maxWidth="md">
        <DialogTitle sx={{ fontWeight: 'bold' }}>Edit Reporter Details & Permissions</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth margin="dense" label="Name" name="name" value={formData.name || ''} onChange={handleEditChange} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth margin="dense" label="Email" name="email" value={formData.email || ''} onChange={handleEditChange} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth margin="dense" label="Address" name="address" value={formData.address || ''} onChange={handleEditChange} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth margin="dense" type="date" label="Date of Birth" name="dateOfBirth" InputLabelProps={{ shrink: true }} value={formData.dateOfBirth || ''} onChange={handleEditChange} />
            </Grid>

            <Grid item xs={12}><Divider sx={{ my: 1 }}>Location Settings</Divider></Grid>
            <Grid item xs={4}>
                <FormControl fullWidth margin="dense">
                    <InputLabel>Country</InputLabel>
                    <Select name="country" value={formData.country || ''} label="Country" onChange={handleEditChange}>
                        {countries.map(c => <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={4}>
                <FormControl fullWidth margin="dense" disabled={!formData.country}>
                    <InputLabel>State</InputLabel>
                    <Select name="state" value={formData.state || ''} label="State" onChange={handleEditChange}>
                        {states.map(s => <MenuItem key={s._id} value={s._id}>{s.name}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={4}>
                <FormControl fullWidth margin="dense" disabled={!formData.state}>
                    <InputLabel>City</InputLabel>
                    <Select name="city" value={formData.city || ''} label="City" onChange={handleEditChange}>
                        {cities.map(c => <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12}><Divider sx={{ my: 1 }}>Permissions (Direct Post)</Divider></Grid>
            <Grid item xs={6} sm={4}><FormControlLabel control={<Switch checked={formData.canDirectPost} onChange={handleEditChange} name="canDirectPost" color="primary" />} label="Direct News" /></Grid>
            <Grid item xs={6} sm={4}><FormControlLabel control={<Switch checked={formData.canDirectVideo} onChange={handleEditChange} name="canDirectVideo" color="primary" />} label="Direct Video" /></Grid>
            <Grid item xs={6} sm={4}><FormControlLabel control={<Switch checked={formData.canDirectShorts} onChange={handleEditChange} name="canDirectShorts" color="primary" />} label="Direct Shorts" /></Grid>
            <Grid item xs={6} sm={4}><FormControlLabel control={<Switch checked={formData.canDirectStory} onChange={handleEditChange} name="canDirectStory" color="primary" />} label="Direct Story" /></Grid>
            <Grid item xs={6} sm={4}><FormControlLabel control={<Switch checked={formData.canDirectGoLive} onChange={handleEditChange} name="canDirectGoLive" color="error" />} label="Direct Live" /></Grid>

            <Grid item xs={12}><Divider sx={{ my: 1 }}>Profile Photo</Divider></Grid>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Avatar src={profileImagePreview} sx={{ width: 80, height: 80, border: '1px solid #ccc' }} />
                    <input type="file" name="profileImage" onChange={handleEditChange} style={{ display: 'none' }} id="edit-img-file" />
                    <label htmlFor="edit-img-file"><Button variant="outlined" component="span">Change Image</Button></label>
                    {profileImagePreview && <Button color="error" onClick={handleClearProfileImage}>Remove</Button>}
                </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setEditOpen(false)} color="inherit">Cancel</Button>
          <Button variant="contained" onClick={handleUpdate} sx={{ fontWeight: 'bold' }}>Save All Changes</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ReportersListPage;